console.log("Write custom llos-scripts");  

// Run funcitons
runB2bPopup();
closeB2bPopup();


function runB2bPopup() {
    document.querySelectorAll("quantity-input .quantity__button[name='plus']").forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var input = this.previousElementSibling;
          var qty = parseInt(input.value);
          // console.log(qty)
          if(qty >= 10) {
           document.body.classList.add('show-b2b-popup')
          } 
        });
      });
    
    
    document.querySelectorAll("quantity-input .quantity__button[name='minus']").forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var input = this.nextElementSibling;
          var qty = parseInt(input.value);
          // console.log(qty)
          if(qty <= 10) {
           document.body.classList.remove('show-b2b-popup')
          } 
        });
    });
} 

function closeB2bPopup() {
  // Get settings from the data attributes
  const overlayCloseEnabled = document.querySelector('.popup-b2b').dataset.overlayClose === 'true';
  const escCloseEnabled = document.querySelector('.popup-b2b').dataset.escClose === 'true';
  const f4CloseEnabled = document.querySelector('.popup-b2b').dataset.f4Close === 'true';

  // Function to close the popup
  function closePopup() {
    document.body.classList.remove('show-b2b-popup');
  }

  // Add event listener to close button
  document.querySelectorAll('.popup-b2b .modal-close-button.popup-close').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
    });
  });

  // Add event listener to overlay if enabled
  if (overlayCloseEnabled) {
    document.querySelector('.popup-overlay').addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
    });
  }

  // Add event listener for ESC key if enabled
  if (escCloseEnabled) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closePopup();
      }
    });
  }

  // Add event listener for F4 key if enabled
  if (f4CloseEnabled) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F4') {
        e.preventDefault();
        closePopup();
      }
    });
  }
}

